import "babel-polyfill";
import Vue from "vue";
import ElementUI from "element-ui";
// 使用轮播图
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css/normalize.css";

import "./styles/index.scss";
import "./styles/table.scss";
import "./styles/font.scss";

import store from "./store/store";
import App from "./App.vue";
import router from "./router/index.js";
import VueI18n from 'vue-i18n';
import locale from 'element-ui/lib/locale';


import "./assets/iconfont/iconfont.css";

import { DataTablesServer } from "vue-data-tables";
import messages from '@/assets/i18n';

Vue.use(ElementUI);
Vue.use(DataTablesServer);
Vue.use(VueI18n);
Vue.config.productionTip = false;

//多语言支持
const i18n = new VueI18n({
  locale: (function(){
    if(localStorage.getItem('lang')){
      return localStorage.getItem('lang');
    }
    return 'en';
  }()),
  messages
});

//为了实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value));

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
